module.exports = __webpack_public_path__ + "img/lanzi.136879e7.png";